module.exports = __webpack_public_path__ + "media/assets/images/blog/almater_nosco-small-b40b094f13fcfc7c3a1b5f5b94412acd.jpg";